// Where the "Learn TheCore" chip on the Profile control points.
//
// For now this is Keylens's own in-app TheCore articles (the /thecore Compendium). Because the value
// is a site-relative path, the chip renders as an in-app link (client-side nav, no new-tab, no
// external arrow). TheCore's learning content is moving to a dedicated, separately-owned website;
// when that site is live, swap this single constant for its absolute https URL. The chip detects the
// https scheme and auto-upgrades to an external link (opens in a new tab, carries the off-site
// arrow), at which point the in-app articles can be retired in a follow-up.
export const THECORE_LEARN_URL = "/thecore";
